import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Select, Form, Input, notification} from 'antd';

import {getUser, updateUser} from './actions';
import {bindActionCreators} from "redux";
import {handleFormErrorNotification} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import Permissions from "./permissions";
import Auth from "../services/auth";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const Option = Select.Option;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateUserForm extends Component {
  componentDidMount() {
    this._load();
  }

  _load = () => {
    const {userId} = decodeParams(this.props.match.params);
    this.props.getUser({userId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleConfirmPassword = (rule, value, callback) => {
    const {getFieldValue} = this.props.form;
    if (value && value !== getFieldValue('password')) {
      callback('Both password must be the same');
    }
    callback();
  };

  handleSubmit = e => {
    e.preventDefault();
    const {form: {setFields}} = this.props;
    const {userId} = decodeParams(this.props.match.params);
    this.props.form.validateFields((err, values) => {
      if (err) return;
      this.props.updateUser({...values, userId})
        .then(this.goBack)
        .catch(err => handleFormErrorNotification(err, values, setFields, notification));
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, updating, auth, user} = this.props;
    const {username, permissions} = user || {};
    return (
      <Card title="Update User">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Username"
          >
            {getFieldDecorator('username', {
              rules: [{
                required: true, min: 4
              }],
              initialValue: username,
            })(
              <Input autoFocus/>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Permissions"
          >
            {getFieldDecorator('permissions', {
              rules: [{
                required: true
              }],
              initialValue: permissions,
            })(
              <Select mode="multiple" placeholder="Select permissions">
                {Permissions
                  .filter(x => !x.requirePermission || auth.hasPermission(x.requirePermission))
                  .map(({value, text}) => <Option key={value} value={value}>{text}</Option>)}
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Password"
            extra="Leave empty if you don't want to change the user password"
          >
            {getFieldDecorator('password', {
              rules: [
                {pattern: /^$|^.{8,}$/, message: 'password must be at least 8 characters or empty'}
              ],
              initialValue: '',
            })(
              <Input type="password"/>
            )}
          </FormItem>
          <Form.Item label="Confirm password"
                     {...formItemLayout}
                     extra="Leave empty if you don't want to change the user password"
          >
            {getFieldDecorator('confirmPassword', {
              initialValue: '',
              rules: [
                {required: false, min: 8},
                {validator: this.handleConfirmPassword},
              ]
            })(
              <Input type="password"/>
            )}
          </Form.Item>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || updating || hasErrors(getFieldsError())}
              >
                Update User
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

UpdateUserForm.propTypes = {
  form: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  /* state */
  auth: PropTypes.object.isRequired,
  user: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  updating: PropTypes.bool.isRequired,
  /* actions */
  updateUser: PropTypes.func.isRequired,
  getUser: PropTypes.func.isRequired,
};

const UpdateUserPage = Form.create()(UpdateUserForm);

const mapStateToProps = state => ({
  auth: new Auth(state.auth.token),
  user: state.user.user,
  loading: state.user.userLoading,
  updating: state.user.updatingUser,
});

const mapDispatchToProps = dispatch => ({
  updateUser: bindActionCreators(updateUser, dispatch),
  getUser: bindActionCreators(getUser, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateUserPage);



// WEBPACK FOOTER //
// ./src/User/UpdateUserPage.js